<template>
  <div style="position: absolute; z-index: 50;height: 80%;width: 350px"
       :style="{top:position.top?position.top+'px':'',left:position.left?position.left+'px':'',right:position.right?position.right+'px':'',
       bottom:position.bottom?position.bottom+'px':'',width:size.width,height:size.height}">
    <div ref="sidebarContext">
      <div class="ui sidebar" :class="setDirection(direction)" ref="sidebar" style="width: 100%">
        <slot name="content"></slot>
      </div>
      <div class="pusher" style="visibility: hidden">
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
      name:"sidebar",
    //передоваемые параметры
    props: {
      position: {
        type: Object,
        default: () => {
          return {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }
        }
      },
      size: {
        type: Object,
        default: () => {
          return {
            width: '100px',
            height: '100px'
          }
        }
      },
      isOpen: {
        type: Boolean,
        default: false
      },
      direction: {
        default: 'left'
      }
    },
    // локальное состояние
    data() {
      return {
        sidebar: null
      }
    },
    //вычисляемые свойства (https://ru.vuejs.org/v2/guide/computed.html#Вычисляемые-свойства)
    computed: {},

    mounted() {
      this.sidebar = $(this.$refs.sidebar).sidebar({context: $(this.$refs.sidebarContext)}).sidebar('setting', 'transition', 'overlay');
      this.updateVisibility();
    },
    //Методы для изменения локального состояния.Ограничения (https://ru.vuejs.org/v2/guide/list.html#Отслеживание-изменений-в-массивах)
    methods: {
      updateVisibility() {
        this.isOpen ? this.sidebar.sidebar('show') : this.sidebar.sidebar('hide');
      },
      setDirection(direction) {
        return {
          [direction]: true
        }
      }
    },

    components: {},

    watch: {
      isOpen() {
        this.updateVisibility();
      }
    }

  }
</script>

<style scoped>
  .pushable {
    overflow: hidden !important;
  }
</style>
